import { render } from "./Tennis.vue?vue&type=template&id=3705d640&ts=true"
import script from "./Tennis.vue?vue&type=script&lang=ts"
export * from "./Tennis.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__